import {
  Box,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  Alert,
  Paper,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import axios from "axios";
import { useState } from "react";

const Form = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  const handleFormSubmit = async (values, { resetForm }) => {
    setLoading(true);
    setMessage("");
    setError(false);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "http://127.0.0.1:8000/api/admin/utilisateurs",
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage(response.data.message);
      setError(false);
      resetForm();
    } catch (error) {
      setError(true);
      if (error.response) {
        setMessage(error.response.data.message || "Erreur lors de l'ajout.");
      } else {
        setMessage("Impossible de contacter le serveur.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <Header
        title="Créer un utilisateur"
        subtitle="Remplissez le formulaire pour ajouter un nouvel utilisateur"
      />

      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: 3,
          background: "#fafafa",
        }}
      >
        {message && (
          <Alert
            severity={error ? "error" : "success"}
            sx={{ mb: 2, fontSize: "0.9rem" }}
          >
            {message}
          </Alert>
        )}

        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="20px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Nom complet"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.nom}
                  name="nom"
                  error={!!touched.nom && !!errors.nom}
                  helperText={touched.nom && errors.nom}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  type="email"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  type="password"
                  label="Mot de passe"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.mot_de_passe_h}
                  name="mot_de_passe_h"
                  error={!!touched.mot_de_passe_h && !!errors.mot_de_passe_h}
                  helperText={touched.mot_de_passe_h && errors.mot_de_passe_h}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Rôle (admin / user)"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.role}
                  name="role"
                  error={!!touched.role && !!errors.role}
                  helperText={touched.role && errors.role}
                  sx={{ gridColumn: "span 2" }}
                />

                <FormControlLabel
                  control={
                    <Switch
                      checked={values.deux_fa_active}
                      onChange={(e) =>
                        setFieldValue("deux_fa_active", e.target.checked)
                      }
                    />
                  }
                  label="Activer 2FA"
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>

              <Box display="flex" justifyContent="flex-end" mt="30px">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1.2,
                    borderRadius: "8px",
                    fontWeight: "bold",
                  }}
                  disabled={loading}
                >
                  {loading ? "En cours..." : "Créer l'utilisateur"}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

const validationSchema = yup.object().shape({
  nom: yup.string().required("Le nom est requis"),
  email: yup.string().email("Email invalide").required("L'email est requis"),
  mot_de_passe_h: yup
    .string()
    .min(6, "Le mot de passe doit contenir au moins 6 caractères")
    .required("Le mot de passe est requis"),
  role: yup.string().required("Le rôle est requis"),
  deux_fa_active: yup.boolean(),
});

const initialValues = {
  nom: "",
  email: "",
  mot_de_passe_h: "",
  role: "user",
  deux_fa_active: false,
};

export default Form;
